import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const categoryIcons = {
  All: 'Grid',
  Creative: 'PenTool',
  Operations: 'Sliders',
  Knowledge: 'BookOpen',
  Other: 'MoreHorizontal',
};

const DashboardSidebar = ({
  categories,
  activeCategory,
  apps,
  onCategoryChange,
  onLock,
}) => (
  <aside className="dashboard-sidebar">
    <div className="flex items-center gap-3 px-6 h-20">
      <img
        src="https://media-manager-c.questera.ai/greta-media/f3431c01043f6ae8468982ada2c320c1b5f2e30df31f9c1fc9d61ccd4574fa71cea2ac7949ae73f0d2854f304172067e/images/aW1hZ2UvcG5n/5dd897f97c55e1aa90164e2d5d40e6e9.png"
        alt="Vicinity"
        className="h-7 w-auto"
      />
      <span className="text-xs text-slate-400">/ tools</span>
    </div>

    <nav className="px-3 py-6 flex-grow" aria-label="Tool categories">
      <p className="px-3 mb-3 sidebar-label">Browse by team</p>
      {categories.map((category) => {
        const active = activeCategory === category;
        const count = category === 'All'
          ? apps.length
          : apps.filter((app) => app.category === category).length;

        return (
          <button
            key={category}
            type="button"
            onClick={() => onCategoryChange(category)}
            className="sidebar-link"
            data-active={active}
          >
            {active && (
              <motion.div layoutId="sidebar-active" className="sidebar-active" />
            )}
            <SafeIcon name={categoryIcons[category]} className="relative text-sm" />
            <span className="relative flex-grow text-left">{category}</span>
            <span className="relative font-mono text-[11px] opacity-70">{count}</span>
          </button>
        );
      })}
    </nav>

    <div className="sidebar-support">
      <p className="sidebar-label mb-2">Help</p>
      <a href="mailto:it@vicinity.studio?subject=Tools%20portal%20access">
        <SafeIcon name="Key" />
        Request access
      </a>
      <a href="mailto:it@vicinity.studio?subject=Tools%20portal%20problem">
        <SafeIcon name="AlertCircle" />
        Report a problem
      </a>
      <button type="button" onClick={onLock}>
        <SafeIcon name="Lock" />
        Lock portal
      </button>
      <p className="internal-label">Internal use only</p>
    </div>
  </aside>
);

export default DashboardSidebar;